import { createClient } from "@supabase/supabase-js";

// Try environment variables first, fallback to prompt user
const url = process.env.REACT_APP_SUPABASE_URL;
const key = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!url || !key) {
  throw new Error("Supabase credentials missing. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY.");
}

export const supabase = createClient(url, key, {
  auth: { persistSession: true, detectSessionInUrl: true },
});
